import { createFileRoute } from "@tanstack/react-router";
import { ContractInactivePharmaciesPage } from "@/features/contracts/contract-inactive-pharmacies-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/nieaktywne-apteki")({
	component: ContractInactivePharmaciesPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.nieaktywne-apteki",
			location.pathname,
		);
	},
});
